import { render, staticRenderFns } from "./NestedDraggable.vue?vue&type=template&id=18282620&scoped=true&"
import script from "./NestedDraggable.vue?vue&type=script&lang=js&"
export * from "./NestedDraggable.vue?vue&type=script&lang=js&"
import style0 from "./NestedDraggable.vue?vue&type=style&index=0&id=18282620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18282620",
  null
  
)

export default component.exports